import React, { Component } from 'react'
import { SiteSlidebarRight } from '../General/SiteSlidebars' 
import hasSlidebarRight from '../hoc/hasSlidebarRight'
import hasHtmlClass from '../hoc/hasHtmlClass'
import SiteLogo from '../General/SiteLogo'
import SiteNavigationDesktop from '../SiteNavigation/SiteNavigationDesktop'
import SiteNavigationMobile from '../SiteNavigation/SiteNavigationMobile'
import config from '../config.json'
import SiteNavigationToggle from '../SiteNavigation/SiteNavigationToggle'
import MultisiteSelector from './MultisiteSelector';
import { MASTERMULTICINEMA, MASTERMULTINAVIGATION, MASTERMULTITOTAL } from '../constants/multiCinemaModes'
import { ADVERTISEMENT_FIREPLACE } from '../constants/advertisementTypes'
import { COMPESO, DIESEL } from '../constants/paymentProvider'
import UserContent from './UserContent'
import getAdvertisementData from '../functions/getAdvertisementData'
import UserContentCompeso from './UserContentCompeso'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { BOTTOMMENUDATA, CLI, FEATURES, FRONT, MULTISITESELECTOR, PROGRAM_ADVERTISEMENTS, PROGRAM_ATTRIBUTES, PROGRAM_CINEMAS, PROGRAM_MOVIES, SITE, SITEHEADERDATA, SOCIALMEDIA, THEME, TOPMENUDATA, TRANSLATION } from '../constants/state'
import getData from '../functions/getData'
import withUseCssVars from '../hooks/withUseCssVars'
import isWebApp from '../functions/isWebApp'
import UserContentDiesel from './UserContentDiesel'

const breakpoints = config.breakpoints

const mapDispatchToProps = (dispatch, ownProps) => ({

})

const mapStateToProps = (state, ownProps) => ({
    siteHeaderData: getData(state, SITEHEADERDATA), 
    attributes: getData(state, PROGRAM_ATTRIBUTES), 
    cinemaDataFront: getData(state, FRONT), 
    topMenuData: getData(state, TOPMENUDATA),
    bottomMenuData: getData(state, BOTTOMMENUDATA), 
    multisiteSelector: getData(state, MULTISITESELECTOR), 
    translation: getData(state, TRANSLATION), 
    features: getData(state, FEATURES),
    socialmediaData: getData(state, SOCIALMEDIA), 
    movies: getData(state, PROGRAM_MOVIES),  
    theme: getData(state, THEME), 
    siteData: getData(state, SITE), 
    cinemas: getData(state, PROGRAM_CINEMAS),
    cliData: getData(state, CLI),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS)
})

class SiteHeader extends Component {
    constructor(props) {
        super(props)

        this.state = {
            cinemagroupIsOpen: false,
            isStickyHeader: false,
            activeUserContent: '',
            isLoggedIn: false,
            cartCount: 0
        }

        this.onScrollPage = this.onScrollPage.bind(this)
        this.toggleCinemaGroups = this.toggleCinemaGroups.bind(this)
        this.toggleUserContent = this.toggleUserContent.bind(this)
        this.updateCart = this.updateCart.bind(this)
        this.updateLoginState = this.updateLoginState.bind(this)
    }

    componentDidMount() {
        if(window.Compeso && window.Compeso.getLogin()) {
            this.setState({
                isLoggedIn: true
            })
        }

        if(window.Compeso && window.Compeso.getCart()) {
            const cart = window.Compeso.getCart()
            const cartItems = cart.items
            if(cartItems.length !== this.state.cartCount)
            this.setState({
                cartCount: cartItems.length
            })
        }

        window.addEventListener('scroll', this.onScrollPage)

        if(window.Compeso) {
            window.Compeso.setCartChangedCallback(this.updateCart);
            window.Compeso.setLoginChangedCallback(this.updateLoginState);
        }

        if(typeof SoftlineDieselkino !== "undefined") {
            SoftlineDieselkino.onAuthStateChanged(this.updateLoginState)
            SoftlineDieselkino.onCartChanged(this.updateCart)
        }

        setTimeout(function () {
            const header = document.getElementById('site-header')
            const fireplace = document.getElementById('fireplace')
            //    if(header && headerAppearance !== 'filled_with_color') {
           if(header && fireplace) {
               const headerHeight = header ? header.offsetHeight - 37 : 140
    
               if(!header.style.marginBottom) {
                   header.style.marginBottom = '-' + headerHeight + 'px' 
               }
           }
       }, 100) 
    }

    updateCart(cart) {
        if(cart) {
            if(cart.items) {
                const cartItems = cart.items
                let currentCartCount = 0
        
                cartItems.forEach((item) => {
                    return currentCartCount += item.amount
                }) 
        
                if(currentCartCount !== this.state.cartCount)
                this.setState({
                    cartCount: currentCartCount
                })
            } else if(cart.itemCount) {
                this.setState({
                    cartCount: cart.itemCount
                })
            }
        } else {
            this.setState({
                cartCount: 0
            })
        }
    }
    
    updateLoginState(login) {
        if(login) {
            if(!this.state.isLoggedIn) {
                this.setState({
                    isLoggedIn: true
                })
            }
        } else {
            if(this.state.isLoggedIn) {
                this.setState({
                    isLoggedIn: false
                })
            }        
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage) 
    }

    onScrollPage() {
        let isStickyHeader = window.scrollY > 100
        let  filteredAdvertisements

        if(this.state.advertisements) {
            filteredAdvertisements = getAdvertisementData(this.state.advertisements, [ADVERTISEMENT_FIREPLACE]) 

            if(filteredAdvertisements[ADVERTISEMENT_FIREPLACE].length !== 0) {
                const fireplace = document.getElementById('fireplace')
                isStickyHeader = fireplace ? fireplace.offsetHeight === 0 ? window.scrollY > 100 : this.state.isStickyHeader === false ? window.scrollY > (100 + fireplace.offsetHeight) : window.scrollY > (fireplace.offsetHeight - 20) : window.scrollY > 100
            }
        }

        if (isStickyHeader !== this.state.isStickyHeader) {
            this.setState({ 
                isStickyHeader: isStickyHeader
            });
        }
    }

    toggleCinemaGroups(boolean) {
        const { addHtmlClass, removeHtmlClass } = this.props
        const { cinemagroupIsOpen } = this.state

        if(boolean || boolean === false) {
            this.setState({
                cinemagroupIsOpen: false
            })
            removeHtmlClass('navigation-is-active')
            removeHtmlClass('multicinema-selector-is-active')
            this.onScrollPage()
            
        } else if(cinemagroupIsOpen) {
            this.setState({
                cinemagroupIsOpen: false
            })
            
            removeHtmlClass('navigation-is-active')
            removeHtmlClass('multicinema-selector-is-active')
            this.onScrollPage()
            
        } else {
            this.setState({
                cinemagroupIsOpen: true,
                isStickyHeader: false
            })

            addHtmlClass('multicinema-selector-is-active')
            addHtmlClass('navigation-is-active')
        }
    }

    toggleUserContent(type) {
        const {activeUserContent} = this.state
        const { addHtmlClass, removeHtmlClass } = this.props

        if(type === '') {
            this.setState({
                activeUserContent: type
            })
            removeHtmlClass('navigation-is-active')

        } else if(type === activeUserContent) {
            this.setState({
                activeUserContent: ''
            })
            removeHtmlClass('navigation-is-active')

        } else {
            this.setState({
                activeUserContent: type
            })
            addHtmlClass('navigation-is-active')
        }
    }

    sortCinemas = (cinemas) => {
        let sortedCinemas
        const singleCinemasOnly = _.filter(cinemas, (cinema) => {
            const type = cinema.scope.type
    
            return type === "single"
        })
    
        if(singleCinemasOnly && singleCinemasOnly.length !== 0) {
            sortedCinemas = singleCinemasOnly.sort(function(a, b) {
                const aCinema = a.nameDisplay
                const bCinema = b.nameDisplay 
                
                return bCinema > aCinema ? -1 : bCinema < aCinema ? 1 : 0
            })
        }
    
        return sortedCinemas
    }

    render() {
        const { 
            isLoggedIn, 
            cartCount,
            isStickyHeader, 
            cinemagroupIsOpen
        } = this.state
        const { 
            displaySidebarRight, 
            onSidebarRightToggle, 
            addHtmlClass, 
            removeHtmlClass, 
            isMobile,
            siteHeaderData,
            attributes,
            cinemaDataFront,
            topMenuData,
            bottomMenuData,
            multisiteSelector,
            translation,
            features,
            socialmediaData,
            movies,
            theme,
            siteData,
            cinemas,
            cliData
        } = this.props 

        const {
            program_overview_submenus,
            header_appearance,
            multicinema_selector_styling,
            multicinema_selector_display,
            hide_multicinema_selector_on_apps
        } = cinemaDataFront

        const {
            url_program_overview
        } = siteData

        const {
            homeURL
        } = siteHeaderData

        const {
            multiCinemaMode,
            currentCinemaId,
            clusterCinemaOption,
            clusterCinemaName,
            cinemaUserTextHint
        } = cliData

        const cinemasObjects = cinemas ? cinemas : null
        const stickyHeaderClass = isStickyHeader ? ' sticky-site-header' : ''
        const cinemaSelectorLogo = multicinema_selector_styling ? multicinema_selector_styling === 'logo_selector' ? true : isMobile ? true : false : false
        const cinemagroupClassName = cinemagroupIsOpen ? ' is-open' : ' is-close'
        const additionalClass = cinemaSelectorLogo ? ' same-brand' : isMobile ? ' same-brand' : ''
        const hasLoginClass = features && features.has_userbar ? ' login-header' : ''
        const hasVoucherShop = features && features.has_voucher_shop ? features.has_voucher_shop : false
        const hasConcessionShop = features && features.has_concession_shop ? features.has_concession_shop : false
        const hasloyaltyCard = features && features.has_loyalty_card ? features.has_loyalty_card : false
        const hasCinemaSelector = (multiCinemaMode === MASTERMULTICINEMA || multiCinemaMode === MASTERMULTINAVIGATION || multiCinemaMode === MASTERMULTITOTAL)
        const currentCinemaData = currentCinemaId && cinemasObjects ? cinemasObjects[currentCinemaId] : null
        const cinemasSorted = this.sortCinemas(cinemasObjects)
        const shopData = currentCinemaData && currentCinemaData.scope.cinemaDataProvider ? currentCinemaData.scope.cinemaDataProvider : null
        const affiliateSlug = currentCinemaData && currentCinemaData.scope.elbenwaldSettings && currentCinemaData.scope.elbenwaldSettings.affiliateSlug ? currentCinemaData.scope.elbenwaldSettings.affiliateSlug : null
        const hasCompesoLogin = features && features.has_login ? shopData && shopData.type === COMPESO ? true : false : false
        const hasDieselLogin = features && features.has_login ? shopData && shopData.type === DIESEL ? true : false : false
        const cinemaName = clusterCinemaOption ? clusterCinemaName : currentCinemaData ? currentCinemaData.nameDisplay : ''
        const showMulticinemaSelectorDesktop = !isMobile && (multicinema_selector_display === 'default' ||  multicinema_selector_display === "desktop_only")
        const showMulticinemaSelectorMobile = isMobile && (multicinema_selector_display === 'default' ||  multicinema_selector_display === "mobile_only")
        const hideSelectorInApp = isWebApp() && hide_multicinema_selector_on_apps

        let urlOrigin
        let loginUrl
        let logoutUrl
        let myAccountUrl
        let checkoutUrl
        let vouchersUrl
        let concessionsUrl
        let shopUrl
        let loyaltyCardUrl
    
        if(shopData && shopData.type === COMPESO) {
            shopUrl = shopData.shopUrl
            const shopCenterId = shopData.shopCenterId
            const baseUrl = shopUrl + "landingpage?center=" + shopCenterId + "&language=" + translation.currentLang.toUpperCase()

            loginUrl        = baseUrl + "&page=login"
            logoutUrl       = baseUrl + "&page=logout"
            myAccountUrl    = baseUrl + "&page=myaccount"
            checkoutUrl     = baseUrl + "&page=checkout"
            vouchersUrl     = baseUrl + "&page=productlist"
            concessionsUrl  = baseUrl + "&page=retaillist"
        } else if (shopData && shopData.type === DIESEL) {
            const baseUrl = 'https://kinoapi.dieselkino.at/'
            loginUrl        = baseUrl + "login"
            logoutUrl       = null
            myAccountUrl    = baseUrl + "shop/user"
            checkoutUrl     = baseUrl + "shop/cart"
            loyaltyCardUrl  = baseUrl + "shop/loyalty-cards"
            vouchersUrl     = baseUrl + "shop/voucher"
            concessionsUrl  = null
        }

        if(homeURL) {
            const url = new URL(homeURL)
            urlOrigin = url.origin
        }
        
        return (
            <div className={"site-header-background"  + stickyHeaderClass + additionalClass + hasLoginClass}>
                {features && features.has_userbar ? hasCompesoLogin ? (
                    <UserContentCompeso
                        hasLogin={true}
                        isLoggedIn={isLoggedIn}
                        shopUrl={shopUrl}
                        translation={translation}
                        cartCount={cartCount}
                        hasConcessionShop={hasConcessionShop}
                        hasVoucherShop={hasVoucherShop}
                        myAccountUrl={myAccountUrl}
                        loginUrl={loginUrl}
                        logoutUrl={logoutUrl}
                        checkoutUrl={checkoutUrl}
                        cinemaUserTextHint={cinemaUserTextHint}
                        vouchersUrl={vouchersUrl}
                        concessionsUrl={concessionsUrl}
                        programOverviewUrl={url_program_overview}
                        addHtmlClass={addHtmlClass}
                        affiliateSlug={affiliateSlug}
                        removeHtmlClass={removeHtmlClass}
                        features={features}
                        />
                    ) : hasDieselLogin ? (
                    <UserContentDiesel
                        hasLogin={true}
                        isLoggedIn={isLoggedIn}
                        shopUrl={shopUrl}
                        hasloyaltyCard={hasloyaltyCard}
                        translation={translation}
                        cartCount={cartCount}
                        loyaltyCardUrl={loyaltyCardUrl}
                        hasConcessionShop={hasConcessionShop}
                        hasVoucherShop={hasVoucherShop}
                        myAccountUrl={myAccountUrl}
                        loginUrl={loginUrl}
                        logoutUrl={logoutUrl}
                        checkoutUrl={checkoutUrl}
                        cinemaUserTextHint={cinemaUserTextHint}
                        vouchersUrl={vouchersUrl}
                        concessionsUrl={concessionsUrl}
                        programOverviewUrl={url_program_overview}
                        addHtmlClass={addHtmlClass}
                        affiliateSlug={affiliateSlug}
                        removeHtmlClass={removeHtmlClass}
                        features={features}
                        />
                    ) : (
                        <UserContent 
                        hasLogin={false}
                        hasConcessionShop={false}
                        affiliateSlug={affiliateSlug}
                        hasVoucherShop={false}
                        translation={translation}
                        programOverviewUrl={url_program_overview}
                        features={features}
                    />
                ) : ('')}
                <div className="grid-site-wrapper">
                    <div className="header-container">
                        <div className="item-header logo-wrapper">
                            <SiteLogo 
                                siteHeaderData={siteHeaderData}
                                isMobile={isMobile}
                                cinemaData={currentCinemaData}
                                cinemaSelectorLogo={cinemaSelectorLogo}
                                className={cinemagroupClassName}
                                multisiteSelector={multisiteSelector}
                                hideSelectorInApp={hideSelectorInApp}
                                theme={theme}
                                translation={translation}
                                currentCinemaId={currentCinemaId}
                                cinemasSorted={cinemasSorted}
                                toggleCinemaGroups={this.toggleCinemaGroups}
                                hasCinemaSelector={hasCinemaSelector}
                                showMulticinemaSelectorMobile={showMulticinemaSelectorMobile}
                            />
                            {!isMobile && cinemaSelectorLogo && hasCinemaSelector && showMulticinemaSelectorDesktop && !hideSelectorInApp && <MultisiteSelector 
                                siteName={currentCinemaData ? currentCinemaData.nameDisplay : ''}
                                cinemaSelectorLogo={cinemaSelectorLogo}
                                className={cinemagroupClassName}
                                multisiteSelector={multisiteSelector}
                                theme={theme}
                                translation={translation}
                                currentCinemaId={currentCinemaId}
                                cinemasSorted={cinemasSorted}
                                toggleCinemaGroups={this.toggleCinemaGroups}
                            />}
                            {isMobile && <SiteNavigationToggle
                                onToggle={onSidebarRightToggle}
                                isActive={false}
                            />}
                        </div>

                        <div className="item-header navigation-wrapper">
                            {!isMobile && <SiteNavigationDesktop
                                programOverviewSubmenus={program_overview_submenus}
                                menuItemsData={topMenuData}
                                translation={translation}
                                movies={movies}
                                attributes={attributes}
                                addHtmlClass={addHtmlClass}
                                removeHtmlClass={removeHtmlClass}
                                toggleCinemaGroups={this.toggleCinemaGroups}
                            />}
                        </div>
                        {!isMobile && !cinemaSelectorLogo && hasCinemaSelector && showMulticinemaSelectorDesktop && !hideSelectorInApp && <MultisiteSelector 
                            siteName={cinemaName}
                            className={cinemagroupClassName}
                            theme={theme}
                            translation={translation}
                            currentCinemaId={currentCinemaId}
                            cinemaSelectorLogo={cinemaSelectorLogo}
                            multisiteSelector={multisiteSelector}
                            cinemasSorted={cinemasSorted}
                            toggleCinemaGroups={this.toggleCinemaGroups}
                        />}
                    </div>

                    {displaySidebarRight && 
                        <SiteSlidebarRight isNavigation={true} headerAppearance={header_appearance} removeHtmlClass={removeHtmlClass}>
                            <div 
                                className="site-slidebar-overlay accent-color-background-half-transparent" 
                                onClick={onSidebarRightToggle}
                            />

                            <div className="site-slidebar-content accent-color-background-half-transparent">
                                <div className="item-header item-header-mobile logo-wrapper">
                                    <SiteLogo 
                                        siteHeaderData={siteHeaderData}
                                    />

                                    <SiteNavigationToggle
                                        onToggle={onSidebarRightToggle}
                                        isActive={true}
                                    />
                                </div>
                                <div className="item-header navigation-wrapper">
                                    <div className="multisite-selector-mobile">
                                    {hasCinemaSelector && multicinema_selector_display !== 'hidden' && !hideSelectorInApp && <MultisiteSelector 
                                            theme={theme}
                                            className={cinemagroupClassName}
                                            multisiteSelector={multisiteSelector}
                                            currentCinemaId={currentCinemaId}
                                            translation={translation}
                                            cinemasSorted={cinemasSorted}
                                            toggleCinemaGroups={this.toggleCinemaGroups}
                                        />}
                                    </div>
                                    <SiteNavigationMobile 
                                        menuItemsData={topMenuData}
                                        programOverviewSubmenus={program_overview_submenus}
                                        translation={translation}
                                        onToggleNavigation={onSidebarRightToggle}
                                        socialmediaData={socialmediaData}
                                        movies={movies}
                                        attributes={attributes}
                                        programOverviewUrl={url_program_overview}
                                        servicePagesMenuData={bottomMenuData}
                                    />
                                </div>
                            </div>
                        </SiteSlidebarRight>
                    }
                </div>
            </div>
        )
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(withUseCssVars(hasHtmlClass(hasSlidebarRight({breakpoint: breakpoints.slidebarNav})(SiteHeader))))



